module.exports = __webpack_public_path__ + "h5-static/img/img_home_tuangou02@3x.3cf866f0.png";